import type { Message } from '@/lib/types';

interface ChatMessageProps {
  message: Message;
  isStreaming?: boolean;
}

export function ChatMessage({ message, isStreaming = false }: ChatMessageProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start gap-2'} mb-4`}>
      {/* Assistant avatar */}
      {!isUser && (
        <div className="w-7 h-7 rounded-full accent-bg flex items-center justify-center flex-shrink-0 mt-1">
          <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
          </svg>
        </div>
      )}
      <div
        className={`
          max-w-[80%] px-4 py-3
          ${isUser ? 'rounded-2xl rounded-br-md' : 'rounded-2xl rounded-bl-md'}
          ${
            isUser
              ? 'accent-bg text-white'
              : 'bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-slate-100'
          }
        `}
      >
        {/* Role indicator */}
        <div className="text-xs opacity-60 mb-1 font-medium">
          {isUser ? 'You' : 'Companion'}
        </div>

        {/* Message content */}
        <div className="prose prose-sm dark:prose-invert max-w-none">
          {message.content.split('\n\n').map((paragraph, idx) => (
            <p key={idx} className="mb-2 last:mb-0">
              {paragraph}
            </p>
          ))}
        </div>

        {/* Streaming indicator */}
        {isStreaming && (
          <span className="inline-flex gap-1 ml-1 items-center">
            <span className="w-1.5 h-1.5 rounded-full bg-current animate-typing-dot"></span>
            <span className="w-1.5 h-1.5 rounded-full bg-current animate-typing-dot" style={{ animationDelay: '0.2s' }}></span>
            <span className="w-1.5 h-1.5 rounded-full bg-current animate-typing-dot" style={{ animationDelay: '0.4s' }}></span>
          </span>
        )}
      </div>
    </div>
  );
}
